module.exports = __webpack_public_path__ + "./fonts/Pe-icon-7-stroke.woff";